module.exports = __webpack_public_path__ + "static/media/rank-1.6edec3aa.svg";